import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaErrorPopupComponent } from './viva-error-popup.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    VivaErrorPopupComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    VivaErrorPopupComponent
  ]
})
export class  VivaErrorPopupModule { }
